import mapApiErrorsToFormikErrors from '../../../form/mapApiErrorsToFormikErrors';

export default function mapPublicationApiErrorsToFormikErrors(apiErrors) {
  const formatedViolations = [];
  for (let violation of apiErrors.errors.violations) {
    if (!violation.propertyPath.startsWith('linkIds')) {
      formatedViolations.push(violation);
      continue;
    }

    formatedViolations.push({
      ...violation,
      propertyPath: `${violation.propertyPath.replace(
        'linkIds',
        'linkedPublications'
      )}.publication`,
    });
  }

  return mapApiErrorsToFormikErrors({
    ...apiErrors,
    errors: {
      ...apiErrors.errors,
      violations: formatedViolations,
    },
  });
}
